import { createRouter, createWebHistory,createWebHashHistory } from "vue-router";
// 引入路由各页面配置
import routes from "./routes";

const router = createRouter({
  // history: createWebHashHistory(process.env.BASE_URL), //createWebHashHistory   createWebHistory
  history: createWebHistory("/"),
  routes,
});

export default router;
